export const EDDY_PROJECT_POLL_ID = 'app/eddy/eddy-project-poll';
